import { render } from "./orderBasicInfo.vue?vue&type=template&id=b5efcbb6&scoped=true"
import script from "./orderBasicInfo.vue?vue&type=script&lang=js"
export * from "./orderBasicInfo.vue?vue&type=script&lang=js"

import "./orderBasicInfo.vue?vue&type=style&index=0&id=b5efcbb6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5efcbb6"]])

export default __exports__